import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useFocusRing } from "@react-aria/focus";
import styled, { css } from "styled-components";
import { Tooltip } from "./Tooltip.js";
import { token } from "./token.js";
import { mergeRefs } from "./mergeRefs.js";
const InteractiveIcon = forwardRef(({
  icon,
  onClick,
  isTooltipShown = false,
  label,
  isDisabled = false,
  tabIndex,
  ...props
}, ref) => {
  const {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  return isTooltipShown ? /* @__PURE__ */ jsx(Tooltip, {
    content: label,
    isOpen: isFocusVisible ? true : void 0,
    children: (triggerProps) => /* @__PURE__ */ jsx(InteractiveIconWrapper, {
      ...props,
      ...triggerProps,
      ...focusProps,
      ref: mergeRefs(ref, triggerProps.ref),
      onClick,
      disabled: isDisabled,
      type: "button",
      "aria-label": label,
      $isFocusVisible: isFocusVisible,
      tabIndex,
      children: icon
    })
  }) : /* @__PURE__ */ jsx(InteractiveIconWrapper, {
    ref,
    ...props,
    ...focusProps,
    onClick,
    disabled: isDisabled,
    type: "button",
    "aria-label": label,
    $isFocusVisible: isFocusVisible,
    tabIndex,
    children: icon
  });
});
const InteractiveIconWrapper = styled.button.withConfig({
  displayName: "InteractiveIconWrapper",
  componentId: "sc-1ieyeg1-0"
})(["vertical-align:middle;width:24px;height:24px;padding:0;border:none;background:transparent;color:", ";cursor:pointer;&:hover,&:active{color:", ";}&:disabled{color:", ";cursor:not-allowed;}", ""], token.gray600, token.gray800, token.gray200, (props) => props.$isFocusVisible && css(["border-radius:2px;color:", ";box-shadow:0 0 0 2px ", ";outline:none;"], token.gray800, token.gray200));
export {
  InteractiveIcon
};
//# sourceMappingURL=InteractiveIcon.js.map
